<template>

  <div class="select" :id="id">
    <div class="mdc-select mdc-select--outlined"
         :class="{'mdc-select--invalid' : !pristine && !valid,
                'mdc-select--valid' : !pristine && valid}">
      <div class="mdc-select__anchor select--fullwidth"
           :style="style"
      >
        <span class="mdc-select__selected-text-container">
          <span class="mdc-select__selected-text " :style="style" :id="selectedTextId"></span>
        </span>
        <span class="mdc-select__dropdown-icon">
          <svg
              class="mdc-select__dropdown-icon-graphic"
              viewBox="7 10 10 5" focusable="false">
            <polygon
                class="mdc-select__dropdown-icon-inactive"
                stroke="none"
                fill-rule="evenodd"
                points="7 10 12 15 17 10">
            </polygon>
            <polygon
                class="mdc-select__dropdown-icon-active"
                stroke="none"
                fill-rule="evenodd"
                points="7 15 12 10 17 15">
            </polygon>
          </svg>
        </span>
        <bk-outline-notched :label="label" :id="id"/>
      </div>

      <div class="mdc-select__menu mdc-menu mdc-menu-surface select__menu" :style="style">
        <ul class="mdc-list"
            :class="{'mdc-select__menu--max-height': items.length > maxNumberOfItemsShown}"
        >
          <li class="mdc-list-item"
              v-for="item in items"
              :data-value="item.value"
              :class="{'mdc-list-item--selected':item.value === value}"
              role="option"
          >
            <span class="mdc-list-item__ripple"></span>
            <span class="mdc-list-item__text">{{ item.name }}</span>

          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { MDCSelect } from '@material/select'
import SelectFieldMixin from '../mixins/selectField'
import BkOutlineNotched from './BkOutlineNotched'
import BkInputLabel from './BkInputLabel'

export default {
  name: 'bk-select',
  props: {
    /**
     * Value of the select
     */
    value: [String, Number],
    /**
     * flieds of the select
     */
    fields: Array,
    /**
     * Label of the select
     */
    label: String,
    /**
     * Id of the select
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * Width of the select
     */
    width: {
      type: String,
      default: '288px'
    },
    /**
     * True if the select is valid
     */
    valid: {
      type: Boolean,
      default: true
    },

    pristine: {
      type: Boolean,
      default: true
    }
  },
  components: { BkOutlineNotched, BkInputLabel },
  mixins: [SelectFieldMixin],
  mounted () {
    this.mdnSelect = new MDCSelect(this.$el.querySelector('.mdc-select'));
    this.mdnSelect.listen('MDCSelect:change', event => this.onChange(event));
  },
  computed: {
    /**
     * List of all items
     * @returns {ArrayConstructor|*}
     */
    items () {
      const first = this.fields[0];
      if (first && typeof first === 'object' && first.constructor === Object) return this.fields;
      return this.fields.map(it => this.createSelectField(it, it));
    },
    /**
     * Set the width as style tag
     * @returns {{width: (default.props.width|{default, type}), minWidth: (default.props.width|{default, type}), maxWidth: (default.props.width|{default, type})}}
     */
    style () {
      return {
        width: this.width,
        maxWidth: this.width,
        minWidth: this.width
      };
    },
    selectedTextId () {
      return `${this.id}-selected-text`;
    },
    maxNumberOfItemsShown () {
      return 5;
    }
  },
  methods: {
    onChange (event) {
      if (event.detail && event.detail.value) this.$emit('input', event.detail.value);
      else this.$emit('input');
    }
  },
  watch: {
    value (n, o) {
      const index = this.items.findIndex(({ value }) => value == n);
      if (index === -1) return;
      if (this.mdnSelect.getDefaultFoundation().getSelectedIndex() != index) this.mdnSelect.getDefaultFoundation().setSelectedIndex(index);
      document.getElementById(this.selectedTextId).innerText = this.items[index].name;
    }
  }

};
</script>
<style lang="scss" scoped>
.mdc-menu .mdc-list {
    padding-left: 0;
}

.select {
    &--fullwidth {
        width: 100%;
        max-width: 288px;
    }
}

.mdc-select__menu--max-height {
    height: calc(5 * 48px);
}
</style>
